const flagPrefix = 'acre-feature-flag-'

/**
 * Sets a flag according to a predetermined percentage value
 * @param flagName The name of the flag
 * @param percentage The percentage (1-100) that should receive the flag on
 * @param configValue The global config value for the flag
 */
export const randomFlag = (flagName: string, percentage: number, configValue: boolean) => {
  if (configValue) {
    return true
  }
  const flag = window.localStorage.getItem(`${flagPrefix}${flagName}`)
  if (flag !== null && flag !== undefined) {
    return flag === 'true'
  }
  const value = Math.random() * 100 <= percentage
  window.localStorage.setItem(`${flagPrefix}${flagName}`, value ? 'true' : 'false')
  return value
}
